import PropTypes from 'prop-types'

import { leftArrowIconPurple } from 'resources/images'
import { STRING, WEBSITE_URL } from 'resources'
import { LinkContainer, LinkText, ArrowIcon } from './styles'

const ReklaimBackButton = ({ onClick = null }) => (
  <LinkContainer onClick={onClick} href={WEBSITE_URL} rel="noopener noreferrer">
    <ArrowIcon src={leftArrowIconPurple} />
    <LinkText>{STRING.backToReklaimButtonMessage}</LinkText>
  </LinkContainer>
)

ReklaimBackButton.propTypes = {
  onClick: PropTypes.func,
}

export default ReklaimBackButton
